var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

// 网络类型定义
var NetType;
(function (NetType) {
    NetType[NetType["WIFI"] = 1] = "WIFI";
    NetType[NetType["2G"] = 2] = "2G";
    NetType[NetType["3G"] = 3] = "3G";
    NetType[NetType["4G"] = 4] = "4G";
    NetType[NetType["5G"] = 5] = "5G";
    NetType[NetType["MOBILE"] = 6] = "MOBILE";
    NetType[NetType["ETHERNET"] = 7] = "ETHERNET";
    NetType[NetType["OTHER"] = 8] = "OTHER";
})(NetType || (NetType = {}));
// 事件类型定义
var EventType;
(function (EventType) {
    EventType[EventType["EXPOSE"] = 1001] = "EXPOSE";
    EventType[EventType["CLICK"] = 1002] = "CLICK";
    EventType[EventType["EXIT"] = 1003] = "EXIT";
    EventType[EventType["DELETE"] = 1004] = "DELETE";
    EventType[EventType["ADD"] = 1005] = "ADD";
    EventType[EventType["MOVE"] = 1006] = "MOVE";
})(EventType || (EventType = {}));
// 系统类型定义
var SysId;
(function (SysId) {
    SysId[SysId["ANDROID"] = 1] = "ANDROID";
    SysId[SysId["IOS"] = 2] = "IOS";
    SysId[SysId["PC"] = 3] = "PC";
})(SysId || (SysId = {}));
var ProductId;
(function (ProductId) {
    ProductId[ProductId["XINYUE"] = 1] = "XINYUE";
    ProductId[ProductId["XIAOYUE"] = 2] = "XIAOYUE";
    ProductId[ProductId["SVIP"] = 3] = "SVIP";
    ProductId[ProductId["CIEBA"] = 4] = "CIEBA";
    ProductId[ProductId["HELPER"] = 5] = "HELPER";
})(ProductId || (ProductId = {}));
var DataSource;
(function (DataSource) {
    DataSource[DataSource["NATIVE_APP"] = 1] = "NATIVE_APP";
    DataSource[DataSource["PC"] = 2] = "PC";
    DataSource[DataSource["INSIDE"] = 3] = "INSIDE";
    DataSource[DataSource["WECHART_OFFICIAL_WEBSITE"] = 4] = "WECHART_OFFICIAL_WEBSITE";
    DataSource[DataSource["H5_APP"] = 21] = "H5_APP";
    DataSource[DataSource["H5_MOBILE"] = 12] = "H5_MOBILE";
    DataSource[DataSource["H5_PC"] = 22] = "H5_PC";
    DataSource[DataSource["H5_WX_ACCOUNT"] = 11] = "H5_WX_ACCOUNT";
    DataSource[DataSource["H5_WX_MP"] = 23] = "H5_WX_MP";
    DataSource[DataSource["H5_QQ_ACCOUNT"] = 10] = "H5_QQ_ACCOUNT";
    DataSource[DataSource["H5_QQ_MP"] = 24] = "H5_QQ_MP";
    DataSource[DataSource["OTHER"] = 0] = "OTHER";
})(DataSource || (DataSource = {}));
// 登录类型
var LoginType;
(function (LoginType) {
    LoginType[LoginType["QQ"] = 1] = "QQ";
    LoginType[LoginType["WX"] = 2] = "WX";
    LoginType[LoginType["QC"] = 3] = "QC";
})(LoginType || (LoginType = {}));

var pluginTrack = function (probe) {
    probe.expose('trackClick', function (message) {
        probe.report(__assign({ event_type: EventType.CLICK }, message));
    });
};

export { pluginTrack as default };
